import { render, staticRenderFns } from "./Groupmanagement.vue?vue&type=template&id=349208c2&scoped=true&"
import script from "./Groupmanagement.vue?vue&type=script&lang=js&"
export * from "./Groupmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Groupmanagement.vue?vue&type=style&index=0&id=349208c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349208c2",
  null
  
)

export default component.exports